function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** content rendered inside the Level Layout Item */
  children: PropTypes.node
};
var defaultProps = {
  children: null
};

var LevelItem = function LevelItem(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  return React.createElement(
    'div',
    props,
    children
  );
};

LevelItem.propTypes = propTypes;
LevelItem.defaultProps = defaultProps;
export default LevelItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/layouts/Level/LevelItem.js
// module id = 298
// module chunks = 0